import { gql } from "@apollo/client";import { useLazyQuery, useMutation } from "@apollo/client/react";import React, { useState, useEffect, useRef, useMemo } from 'react';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { Outlet } from 'react-router-dom';

import toast, { Toaster } from 'react-hot-toast';
import ErrorDialog from '../../../components/ErrorDialog';
import { InputLabel, Select, Grid, TextField, FormControl, Box, MenuItem, InputAdornment, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { CustomButton } from '../../../components/customButton/CustomButton';
import SearchIcon from '@mui/icons-material/Search';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { GET_CLIENTES_CC, GET_CLIENTES_CC_EXPORT, GET_CLIENTES_CC_DISPONIBLES } from '../../../data/graphQL/queries/ClientesCC/queries';
import moment from 'moment';
import { usePersistFilters } from '../../../hooks/usePersistFilters';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';
import './clientesCCAll.scss';
import { downloadExcel } from '../../../utils/downloadExcel';

export default function ClientesCCAll({ setChildrenAction }) {

  const header = ["Cliente", "CodCliente", "CUIT", "Domicilio", "CP", "Delegación", "Usuario", "Fecha Alta"];

  const FILE_TYPE = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];

  const idUsuario = parseInt(sessionStorage.getItem("idUsuario"), 10);

  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  const [openDlg, setOpenDlg] = useState(false);
  const [loadingDla, setloadingDlg] = useState(false);
  const [labelBtnDlg, setlabelBtnDlg] = useState(false);
  const [textoDlg, setTextoDlg] = useState('');
  const [opcionAccion, setOpcionAccion] = useState(''); // 0: alta. 1: baja

  const [openDlgNuevos, setOpenDlgNuevos] = useState(false);
  const [loadingDlgNuevos, setLoadingDlgNuevos] = useState(false);

  const [delegaciones, setDelegaciones] = useState(null);
  const [clientesAutorizados, setClientesAutorizados] = useState('');
  const [clientesAutorizadosOriginal, setClientesAutorizadosOriginal] = useState('');

  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [rowSelectionModelDispo, setRowSelectionModelDispo] = useState([]);

  const [clientesDisponibles, setClientesDisponibles] = useState('');
  const [clientesDisponiblesOriginal, setClientesDisponiblesOriginal] = useState('');
  const [filtroDelegacionDispo, setFiltroDelegacionDispo] = useState(0);

  const [exportar, setExportar] = useState(false);

  // array con los códigos de clientes a grabar
  const [clientesGrabar, setClientesGrabar] = useState([]);

  const txtBuscar = useRef(null);
  const txtBuscarDispo = useRef(null);

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);

  useEffect(() => {
    if (exportar) {
      getClientesCCExport({ variables: { idDelegacion: filters?.selectedFilterByDelegacion } });
    }

  }, [exportar]);

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
  };

  const { filters, handleChangeFilters } = usePersistFilters(
    {
      selectedFilterByDelegacion: 0
    },
    'clientesFilters'
  );

  useEffect(() => {
    setChildrenAction(() =>
    <div className='clientesCC-all'>
                <CustomButton
        variant='outlined'
        className='margin-right'
        onClick={handleDownloadExcel}>
        
                    Exportar
                </CustomButton>
                <CustomButton
        variant='outlined'
        className='margin-right'
        onClick={handleDesautorizar}>
        
                    Desautorizar
                </CustomButton>
                <CustomButton
        onClick={handleOpenDlgNuevos}>
        
                    Nuevo
                </CustomButton>
            </div>
    );
  }, [rowSelectionModel, filters]);

  useEffect(() => {
    txtBuscar.current.focus();
    getClientesCC({variables: { idDelegacion: filters?.selectedFilterByDelegacion }});
    getDelegaciones({ variables: { idRegion: 0 } });
  }, [filters]);

  const QGetDelegaciones = gql`
        query QGetDelegaciones ($idRegion: Int!) {
            delegaciones (idRegion: $idRegion)
                {
                    success,
                    error,
                    valorEsperado {
                        idRegion,
                        region,
                        idDelegacion,
                        descripcion,
                        activo
                    }
                }
        }`;

  const [getDelegaciones, { errorDelegaciones, data: dataDeleg }] = useLazyQuery(QGetDelegaciones, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataDeleg) return;
    setDelegaciones(dataDeleg.delegaciones.valorEsperado);
  }, [dataDeleg]);

  const [getClientesCC, { error: errorClientesCC, data: dataClientesCC, loading: loadingClientesCC }] = useLazyQuery(GET_CLIENTES_CC, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataClientesCC || loadingClientesCC) return;
    if (dataClientesCC.clientesCC.success) {
      setClientesAutorizados(dataClientesCC.clientesCC.valorEsperado);
      setClientesAutorizadosOriginal(dataClientesCC.clientesCC.valorEsperado);
    };
  }, [dataClientesCC]);

  useEffect(() => {
    if (!errorClientesCC) return;
    setMensajeError("ERRORDB");
  }, [errorClientesCC]);

  const handleSearch = () => {
    // si se ingresó texto a buscar (al menos 3 caracteres) --> filtro, sino retorno todos los registros
    // originales consultados
    if (txtBuscar.current.value != "") {
      if (txtBuscar.current.value.length >= 3) {
        setClientesAutorizados(clientesAutorizadosOriginal.filter((clientesAutorizadosOriginal) => {
          const nombreBuscar = clientesAutorizadosOriginal.cliente.toLowerCase();
          const cuitBuscar = clientesAutorizadosOriginal.cUIT.toLowerCase();
          const codsapBuscar = clientesAutorizadosOriginal.codCliente.toLowerCase();
          const delegacionBuscar = clientesAutorizadosOriginal.delegacion.toLowerCase();

          const inputBuscar = txtBuscar.current.value.toLowerCase();
          return (
            nombreBuscar.includes(inputBuscar) ||
            cuitBuscar.includes(inputBuscar) ||
            codsapBuscar.includes(inputBuscar) ||
            delegacionBuscar.includes(inputBuscar));

        }
        ));
      } else {
        setClientesAutorizados(clientesAutorizadosOriginal);
      }
    } else {
      setClientesAutorizados(clientesAutorizadosOriginal);
    }
  };

  const initialColumns = [
  { field: 'codCliente', headerName: 'Código', flex: 0.2 },
  { field: 'cliente', headerName: 'Cliente', flex: 0.3 },
  { field: 'delegacion', headerName: 'Delegación', flex: 0.45 },
  { field: 'cUIT', headerName: 'CUIT', flex: 0.2 },
  { field: 'domicilio', headerName: 'Domicilio', flex: 0.45 },
  { field: 'cP', headerName: 'CP', flex: 0.1 },
  { field: 'usuario', headerName: 'Usuario Reg.', flex: 0.35 },
  {
    field: 'fechaAlta',
    headerName: 'Fecha Reg.',
    flex: 0.3,
    // type: 'date',
    valueGetter: (value) => value && moment(value).format('DD/MM/YYYY HH:ss')
  }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), []);

  const onRowsSelectionHandler = (ids) => {
    setRowSelectionModel(ids);
  };

  const onRowsSelectionHandlerDispo = (ids) => {
    setRowSelectionModelDispo(ids);
  };

  const handleDownloadExcel = () => {
    setExportar(true);
  };

  const [getClientesCCExport, { error: errorExport, data: dataExport }] = useLazyQuery(GET_CLIENTES_CC_EXPORT, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataExport) return;
    if (dataExport.clientesCC.success) {
      const dataAll = dataExport.clientesCC.valorEsperado;

      const data = dataAll.map((item) => {
        let obj = {
          cliente: item.cliente,
          idInsumo: item.codCliente,
          CUIT: item.cUIT,
          domicilio: item.domicilio,
          CP: item.cP,
          delegacion: item.delegacion,
          usuario: item.usuario,
          fechaAlta: item.fechaAlta
        };

        return obj;
      });

      const opt = 'downloadExcel Method';

      downloadExcel({
        fileName: 'ListadoClientesCC',
        sheet: "Clientes CC",
        tablePayload: {
          header,
          body: data
        }
      });
    };
    setExportar(false);
  }, [dataExport]);

  useEffect(() => {
    if (!errorExport) return;
    setMensajeError("ERRORDB");
    setExportar(false);
  }, [errorExport]);

  const handleDesautorizar = () => {
    if (rowSelectionModel.length > 0) {
      let idsClientes = [];
      setOpcionAccion(1);
      // verifico antes de agregar que no esté incluido ya el código
      rowSelectionModel.map((index) => {
        const nodo = idsClientes.filter((c) => c == clientesAutorizados[index - 1].codCliente);
        if (idsClientes.length == 0 || nodo == "") {
          idsClientes.push(clientesAutorizados[index - 1].codCliente);
        }
      });
      const txtClientes = idsClientes.length > 1 ? "clientes" : "cliente";
      setClientesGrabar(idsClientes);
      setTextoDlg("¿Confirma quitar " + idsClientes.length + " " + txtClientes + " de Autorización Inmediata?");
      setlabelBtnDlg("AUTORIZAR");
      setOpenDlg(true);
    } else {
      toast.error("Debe seleccionar al menos un Cliente para desautorizar.");
    }
  };

  const handleAceptarDlg = () => {
    setloadingDlg(true);
    // ALTA
    if (opcionAccion == 0) {
      saveAutorizarClienteCC({ variables: { idsCliente: clientesGrabar, idUsuario: idUsuario } });
    } else if (opcionAccion == 1) {// BAJA
      saveDesautorizarClienteCC({ variables: { idsCliente: clientesGrabar, idUsuario: idUsuario } });
    }
  };

  const handleCancelarDlg = () => {
    setloadingDlg(false);
    setOpenDlg(false);
  };

  const MSaveDesautorizarClienteCC = gql`
    mutation MSaveDesautorizarClienteCC( $idsCliente: [String!]!, $idUsuario: Int!){
        saveDesautorizarClienteCC (idsCliente: $idsCliente, idUsuario: $idUsuario) 
        {
            success,
            error,
            valorEsperado
        }
      }`;

  const [saveDesautorizarClienteCC, { error: errorDes, data: datosDes }] = useMutation(MSaveDesautorizarClienteCC, {
    onCompleted: (datosDes) => {
      if (datosDes.saveDesautorizarClienteCC.success) {
        toast.success("Clientes desautorizados correctamente!");
        setloadingDlg(false);
        setOpenDlg(false);
        setClientesAutorizados([]);
        setClientesAutorizadosOriginal([]);
        setTimeout(() => {
          txtBuscar.current.value = "";
          getClientesCC({variables: { idDelegacion: filters?.selectedFilterByDelegacion }});
        }, 2000);
      } else if (datosDes.saveDesautorizarClienteCC.error === 'ERRORDB' || parseInt(datosDes.saveDesautorizarClienteCC.error, 10) > 0) {
        setMensajeError(datosDes.saveDesautorizarClienteCC.error);
        return false;
      }
    },
    onError: (datosDes) => {
      setOpenDlg(false);
      setloadingDlg(false);
      setMensajeError("ERRORDB");
      return false;
    }
  });

  const handleOpenDlgNuevos = () => {
    setFiltroDelegacionDispo(filters?.selectedFilterByDelegacion);
    setOpenDlgNuevos(true);
  };

  useEffect(() => {
    getClientesCCDispo({variables: { idDelegacion: filtroDelegacionDispo }});
  }, [filtroDelegacionDispo]);

  const handleCancelarDlgNuevos = () => {
    setOpenDlgNuevos(false);
  };

  const handleAceptarDlgNuevos = () => {
    if (rowSelectionModelDispo.length > 0) {
      let idsClientes = [];
      setOpcionAccion(0);
      // verifico antes de agregar que no esté incluido ya el código
      rowSelectionModelDispo.map((index) => {
        const nodo = idsClientes.filter((c) => c == clientesDisponibles[index - 1].codCliente);
        if (idsClientes.length == 0 || nodo == "") {
          idsClientes.push(clientesDisponibles[index - 1].codCliente);
        }
      });
      const txtClientes = idsClientes.length > 1 ? "clientes" : "cliente";
      setClientesGrabar(idsClientes);
      setTextoDlg("¿Confirma autorizar " + idsClientes.length + " " + txtClientes + " para Autorización Inmediata?");
      setlabelBtnDlg("AUTORIZAR");
      setOpenDlg(true);
    } else {
      toast.error("Debe seleccionar al menos un Cliente para autorizar.");
    }
  };

  const [getClientesCCDispo, { data: dataClientesCCDispo, loading: loadingCCDispo }] = useLazyQuery(GET_CLIENTES_CC_DISPONIBLES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataClientesCCDispo) return;
    if (dataClientesCCDispo.clientesDisponiblesCC.success) {
      setClientesDisponibles(dataClientesCCDispo.clientesDisponiblesCC.valorEsperado);
      setClientesDisponiblesOriginal(dataClientesCCDispo.clientesDisponiblesCC.valorEsperado);
    };
  }, [dataClientesCCDispo]);

  const initialAvailableColumns = [
  { field: 'codCliente' },
  { field: 'cliente', headerName: 'Cliente', flex: 0.3 },
  { field: 'delegacion', headerName: 'Delegación' },
  { field: 'cUIT', headerName: 'CUIT' },
  { field: 'domicilio', headerName: 'Domicilio', flex: 0.4 },
  { field: 'cP', align: 'center', headerName: 'CP', flex: 0.1 }];


  const availableColumns = useMemo(() => generateColumnsDefaultConfiguration(initialAvailableColumns), []);

  const handleSearchDispo = () => {
    // si se ingresó texto a buscar (al menos 3 caracteres) --> filtro, sino retorno todos los registros
    // originales consultados
    if (txtBuscarDispo.current.value != "") {
      if (txtBuscarDispo.current.value.length >= 3) {
        setClientesDisponibles(clientesDisponiblesOriginal.filter((clientesDisponiblesOriginal) => {
          const nombreBuscar = clientesDisponiblesOriginal.cliente.toLowerCase();
          const cuitBuscar = clientesDisponiblesOriginal.cUIT.toLowerCase();
          const codsapBuscar = clientesDisponiblesOriginal.codCliente.toLowerCase();
          const delegacionBuscar = clientesDisponiblesOriginal.delegacion.toLowerCase();

          const inputBuscar = txtBuscarDispo.current.value.toLowerCase();
          return (
            nombreBuscar.includes(inputBuscar) ||
            cuitBuscar.includes(inputBuscar) ||
            codsapBuscar.includes(inputBuscar) ||
            delegacionBuscar.includes(inputBuscar));

        }
        ));
      } else {
        getClientesCCDispo({variables: { idDelegacion: filtroDelegacionDispo }});
      }
    } else {
      getClientesCCDispo({variables: { idDelegacion: filtroDelegacionDispo }});
    }
  };

  const handleChangeFiltroDelegacionDispo = (e) => {
    setFiltroDelegacionDispo(parseInt(e.target.value, 10));
    txtBuscarDispo.current.value = "";
  };

  const MSaveAutorizarClienteCC = gql`
    mutation MSaveAutorizarClienteCC( $idsCliente: [String!]!, $idUsuario: Int!){
        saveAutorizarClienteCC (idsCliente: $idsCliente, idUsuario: $idUsuario) 
        {
            success,
            error,
            valorEsperado
        }
      }`;

  const [saveAutorizarClienteCC, { datosAut }] = useMutation(MSaveAutorizarClienteCC, {
    onCompleted: (datosAut) => {
      if (datosAut.saveAutorizarClienteCC.success) {
        toast.success("Clientes autorizados correctamente!");
        setloadingDlg(false);
        setOpenDlg(false);
        setOpenDlgNuevos(false);
        setClientesDisponibles([]);
        setClientesDisponiblesOriginal([]);
        setTimeout(() => {
          txtBuscar.current.value = "";
          getClientesCC({variables: { idDelegacion: filters?.selectedFilterByDelegacion }});
        }, 2000);
      } else if (datosAut.saveAutorizarClienteCC.error === 'ERRORDB' || parseInt(datosAut.saveAutorizarClienteCC.error, 10) > 0) {
        setMensajeError(datosAut.saveAutorizarClienteCC.error);
        return false;
      }
    },
    onError: (datosAut) => {
      setOpenDlg(false);
      setOpenDlgNuevos(false);
      setloadingDlg(false);
      setMensajeError("ERRORDB");
      return false;
    }
  });

  return (
    <>
            <Box sx={{ width: '100%' }}>
                <Grid container direction="row" spacing={2}>
 <Grid size={{ xs: 6, sm: 3, md: 3, lg: 3 }}>
                        <TextField
              sx={{ backgroundColor: 'white', width: '95%' }}
              label="Buscar"
              name="txtBuscar"
              size="small"
              type="text"
              variant="outlined"
              inputRef={txtBuscar}
              onKeyUp={handleSearch}
              InputProps={{
                endAdornment:
                <InputAdornment position="end">
                                        <SearchIcon
                    onClick={handleSearch}
                    sx={{ cursor: 'pointer' }} />
                  
                                    </InputAdornment>

              }} />
            
                    </Grid>
 <Grid size={{ xs: 12, sm: 4, md: 3, lg: 3 }}>
                        <FormControl fullWidth>
                            <InputLabel id="slDelegacion-lbl" sx={{ fontSize: '9pt' }}>Delegación</InputLabel>
                            <Select
                labelId="slDelegacion-lbl"
                id="slDelegacion"
                value={filters?.selectedFilterByDelegacion}
                onChange={(e) => handleChangeFilters('selectedFilterByDelegacion', e.target.value)}
                label="Delegación"
                sx={{ fontSize: '9pt', maxHeight: "40px", backgroundColor: 'white' }}>
                
                                <MenuItem sx={{ fontSize: '9pt' }} value={0} selected> Seleccionar delegación </MenuItem>
                                {
                delegaciones != null && delegaciones.map((deleg) => {
                  return (
                    <MenuItem key={deleg.idDelegacion} sx={{ fontSize: '9pt' }} value={deleg.idDelegacion}> {deleg.descripcion} </MenuItem>);

                })
                }
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </Box>

            <br />

            <DataGridGenerico
        columns={columns}
        fileNameExport='Clientes CC'
        rows={clientesAutorizados && clientesAutorizados.map((item, index) => {return { id: index + 1, ...item };})}
        toolbar={false}
        checkboxSelection={true}
        disableSelectionOnClick
        onRowSelectionModelChange={(ids) => onRowsSelectionHandler(ids)}
        rowSelectionModel={rowSelectionModel}
        getRowId={(row) => row._id}
        loading={loadingClientesCC}
        totalCount={clientesAutorizados.length} />
      

            <CustomDialog
        fullWidth={true}
        maxWidth="lg"
        open={openDlgNuevos}
        title='Clientes disponibles para Autorizar'
        onCancel={handleCancelarDlgNuevos}
        onAccept={handleAceptarDlgNuevos}
        acceptText={labelBtnDlg || undefined}>
        
                <Grid container direction="row" spacing={2} sx={{ paddingTop: '6px' }}>
 <Grid size={{ xs: 6, sm: 3, md: 3, lg: 3 }}>
                        <TextField
              sx={{ backgroundColor: 'white', width: '95%' }}
              label="Buscar"
              name="txtBuscarDispo"
              size="small"
              type="text"
              variant="outlined"
              inputRef={txtBuscarDispo}
              onKeyUp={handleSearchDispo}
              InputProps={{
                endAdornment:
                <InputAdornment position="end">
                                        <SearchIcon
                    onClick={handleSearchDispo}
                    sx={{ cursor: 'pointer' }} />
                  
                                    </InputAdornment>

              }} />
            
                    </Grid>
 <Grid size={{ xs: 12, sm: 5, md: 3, lg: 3 }}>
                        <FormControl fullWidth>
                            <InputLabel id="slDelegacionDispo-lbl" sx={{ fontSize: '9pt' }}>Delegación</InputLabel>
                            <Select
                labelId="slDelegacionDispo-lbl"
                id="slDelegacionDispo"
                name="delegacionDispo"
                value={filtroDelegacionDispo}
                onChange={handleChangeFiltroDelegacionDispo}
                label="Delegación"
                sx={{ fontSize: '9pt', maxHeight: "40px", backgroundColor: 'white' }}>
                
                                <MenuItem sx={{ fontSize: '9pt' }} value={0} selected> Seleccionar delegación </MenuItem>
                                {
                delegaciones != null && delegaciones.map((deleg) => {
                  return (
                    <MenuItem key={deleg.idDelegacion} sx={{ fontSize: '9pt' }} value={deleg.idDelegacion}> {deleg.descripcion} </MenuItem>);

                })
                }
                            </Select>
                        </FormControl>
                    </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                        <DataGridGenerico
              columns={availableColumns}
              rows={clientesDisponibles && clientesDisponibles.map((item, index) => {return { id: index + 1, ...item };})}
              toolbar={false}
              checkboxSelection={true}
              disableSelectionOnClick
              onRowSelectionModelChange={(ids) => onRowsSelectionHandlerDispo(ids)}
              rowSelectionModel={rowSelectionModelDispo}
              getRowId={(row) => row._id}
              loading={loadingCCDispo}
              totalCount={clientesDisponibles.length} />              
                    </Grid>
                </Grid>
            </CustomDialog>

            <CustomDialog
        maxWidth="md"
        open={openDlg}
        title={'Clientes con Autorización Inmediata'}
        onCancel={handleCancelarDlg}
        onAccept={handleAceptarDlg}
        acceptText={labelBtnDlg || undefined}>
        
                <strong>{textoDlg}</strong>
            </CustomDialog>

            <ErrorDialog
        id="dlg-error-clientes"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError} />
      

            <Outlet />
        </>);

}